import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import styled from "styled-components";



export declare type TvlGraphProps = {
	apy_series: ApySeries;
};



export const TvlGraph = ({
	apy_series,
}: TvlGraphProps) => {

	const formatData = () => {
		return apy_series.map(({ epoch, apy, }) => ({ epoch: `${epoch}`, apy, }));
	};

	const formatTooltip = (value: number, name: string) => {
		if (name === 'apy') {
			return [`${value.toFixed(2)}%`, 'APY'];
		}
		return [value, name];
	};

	const { primary, } = theme;
	return (
		<Container>
			<ResponsiveContainer width="100%" height={200}>
				<LineChart data={formatData()}>
					<CartesianGrid strokeDasharray="3 3" stroke="#333" />
					<XAxis dataKey="epoch" stroke="#666" tick={{ fill: '#666' }} />
					<YAxis stroke="#666" tick={{ fill: '#666' }} />
					<Tooltip 
						contentStyle={{ 
							backgroundColor: '#222', 
							border: '1px solid #444',
							borderRadius: '5px',
							color: '#fff'
						}}
						formatter={formatTooltip}
					/>
					<Line type="monotone"  dataKey="apy"  stroke={primary} strokeWidth={3} dot={{ fill: primary, strokeWidth: 2, r: 4 }} activeDot={{ r: 6, stroke: primary, strokeWidth: 12 }} />
				</LineChart>
			</ResponsiveContainer>
		</Container>
	);
};

const theme = {
	primary: "#03ff8f",
}


export declare type ApySeries = {
	epoch: number;
	apy: number;
}[];



const Container = styled.div`
	background-color: #111;
	border-radius: 10px;
	padding: 10px;
`;
